import React from 'react';
import {Box, Typography} from '@mui/material';

const NAVY   = '#052F44';
const ORANGE = '#FF6900';
const TEAL   = '#1B6B55';

const IMP_ROWS = [
    {country: 'Philippines',    gain: 6},
    {country: 'United Kingdom', gain: 5},
    {country: 'Australia',      gain: 4},
    {country: 'Ireland',        gain: 3},
    {country: 'New Zealand',    gain: 2},
];

const MAX_GAIN = 6; // used to scale bar widths

const ImpRow = ({country, gain}) => (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
        <Typography sx={{fontSize: '14px', color: '#374151', minWidth: '150px', flexShrink: 0}}>
            {country}
        </Typography>
        <Box sx={{flex: 1, height: '22px', borderRadius: '4px', backgroundColor: 'var(--brand-surface-subtle, #E5E7EB)', overflow: 'hidden'}}>
            <Box sx={{
                width: `${(gain / MAX_GAIN) * 100}%`,
                height: '100%',
                backgroundColor: NAVY,
                borderRadius: '4px',
                transition: 'width 0.4s ease',
            }}/>
        </Box>
        <Typography sx={{fontSize: '15px', fontWeight: 700, color: NAVY, minWidth: '36px', textAlign: 'right', flexShrink: 0}}>
            +{gain}
        </Typography>
    </Box>
);

const ImprovementTab = () => (
    <Box>
        <Box sx={{display: 'flex', gap: 2.5, alignItems: 'stretch'}}>

            {/* ── Left: empty trajectory placeholder ── */}
            <Box sx={{
                flex: 1,
                border: '1px solid var(--brand-border, #E5E7EB)',
                borderRadius: '12px',
                backgroundColor: 'var(--brand-surface, #ffffff)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '320px',
            }}>
                <Typography sx={{fontSize: '18px', fontWeight: 800, color: NAVY}}>
                    Portfolio competency trajectory (outcome)
                </Typography>
                <Typography sx={{fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic', lineHeight: 1.6}}>
                    +5 points across three cycles (54 → 57 → 59).
                </Typography>
            </Box>

            {/* ── Right: improvement by country ── */}
            <Box sx={{
                flex: 1,
                border: '1px solid var(--brand-border, #E5E7EB)',
                borderRadius: '12px',
                backgroundColor: 'var(--brand-surface, #ffffff)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                p: 3,
            }}>
                <Typography sx={{fontSize: '18px', fontWeight: 800, color: NAVY, mb: 3}}>
                    Improvement by country (percentage-point gain)
                </Typography>

                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2.2}}>
                    {IMP_ROWS.map((row) => <ImpRow key={row.country} {...row}/>)}
                </Box>

                <Typography sx={{fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic', mt: 3, lineHeight: 1.6}}>
                    Unit stated explicitly: percentage-point gain in composite score. Improvement ≠ activity.
                </Typography>
            </Box>

        </Box>

        {/* Decision guidance footer */}
        <Box sx={{
            mt: 3,
            p: {xs: 2, md: 2.5},
            backgroundColor: 'var(--brand-surface-subtle, #EFF6FF)',
            border: '1px solid #BFDBFE',
            borderLeft: `4px solid ${NAVY}`,
            borderRadius: '0 8px 8px 0',
        }}>
            <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.7}}>
                <strong style={{color: NAVY}}>Decision guidance:&nbsp;</strong>
                High-growth new markets (Philippines, NZ) are strong proof points — but their data is still
                thin. Pair every improvement claim with the coverage figure before using it in a renewal.
            </Typography>
        </Box>
    </Box>
);

export default ImprovementTab;
